import {
  useProjectId,
  useServiceName,
  usePackageId,
  useGetPackagesByTypeQuery,
} from '@consigli/hooks';

import { convertServiceNameToId, PackageList } from './package-list';

export const DocumentPackageList = () => {
  const projectId = useProjectId();
  const serviceName = useServiceName();
  const packageId = usePackageId();
  const { data: packages = [] } = useGetPackagesByTypeQuery({
    projectId,
    type: convertServiceNameToId(serviceName),
  });

  return <PackageList packages={packages} id={packageId} />;
};
